import {Component} from '@angular/core';
@Component({
    selector: 'app-hero-alt',
    templateUrl: './hero-alt.component.html',
    styleUrls: ['./hero-alt.component.scss'],
    standalone: false
})
export class HeroAltComponent {
}
